import React from 'react';
import { Column, Columns, Input } from '@agconnections/grow-ui';
import { useFormikContext } from 'formik';
import './index.css';

const ChemicalElementsSection = () => {
  const { setFieldValue } = useFormikContext();
  return (
    <div name="ChemicalSection" data-testid="product-chemical-section">
      <div className="mt-12 font-bold text-lg">Major</div>
      <div className="mt-12">
        <Columns wrap>
          <Column width="w-1/4">
            <div className="pr-2">
              <Input
                id="n-input"
                type="number"
                name="formulation.N"
                label="N"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.N', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2 pr-2">
              <Input
                id="p-input"
                type="number"
                name="formulation.P"
                label="P"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.P', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2">
              <Input
                id="k-input"
                type="number"
                name="formulation.K"
                label="K"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.K', e.target.value);
                }}
              />
            </div>
          </Column>
        </Columns>
      </div>
      <div className="mt-12 font-bold text-lg">Minor</div>
      <div className="mt-12">
        <Columns wrap>
          <Column width="w-1/4">
            <div className="pr-2">
              <Input
                id="c-ainput"
                type="number"
                name="formulation.Ca"
                label="Ca"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Ca', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2 pr-2">
              <Input
                id="mg-input"
                type="number"
                name="formulation.Mg"
                label="Mg"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Mg', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2">
              <Input
                id="s-input"
                type="number"
                name="formulation.S"
                label="S"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.S', e.target.value);
                }}
              />
            </div>
          </Column>
        </Columns>
      </div>
      <div className="mt-12 font-bold text-lg">Micro</div>
      <div className="mt-12">
        <Columns wrap>
          <Column width="w-1/4">
            <div className="pr-2">
              <Input
                id="fe-input"
                type="number"
                name="formulation.Fe"
                label="Fe"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Fe', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2 pr-2">
              <Input
                id="cu-input"
                type="number"
                name="formulation.Cu"
                label="Cu"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Cu', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2">
              <Input
                id="mn-input"
                type="number"
                name="formulation.Mn"
                label="Mn"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Mn', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2">
              <Input
                id="zn-input"
                type="number"
                name="formulation.Zn"
                label="Zn"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Zn', e.target.value);
                }}
              />
            </div>
          </Column>
        </Columns>
      </div>
      <div className="mt-12">
        <Columns wrap>
          <Column width="w-1/4">
            <div className="pr-2">
              <Input
                id="b-input"
                type="number"
                name="formulation.B"
                label="B"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.B', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2 pr-2">
              <Input
                id="mo-input"
                type="number"
                name="formulation.Mo"
                label="Mo"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Mo', e.target.value);
                }}
              />
            </div>
          </Column>
          <Column width="w-1/4">
            <div className="pl-2">
              <Input
                id="cl-input"
                type="number"
                name="formulation.Cl"
                label="Cl"
                placeholder="0%"
                onChange={e => {
                  setFieldValue('formulation.Cl', e.target.value);
                }}
              />
            </div>
          </Column>
        </Columns>
      </div>
    </div>
  );
};
export default ChemicalElementsSection;
